import { useTheme } from '@mui/material'
import { ReactNode } from 'react'

interface IProps {
  children: ReactNode
}

export const AuthFormWrapper = ({ children }: IProps) => {
  const theme = useTheme()

  return (
    <div
      // style={
      //   isLaptop
      //     ? {}
      //     : {
      //         position: 'absolute',
      //         top: '50%',
      //         left: '50%',
      //         transform: 'translate(-50%,-50%)',
      //       }
      // }
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      }}
    >
      {children}
    </div>
  )
}
